/**
 * Return an rray of dates between the start & end dates (included), given a granularity
 * @param  {moment} startDate         - interval starting date
 * @param  {moment} endDate           - interval ending date
 * @param  {String} [precision='day'] - interval between 2 rows
 * @return {moment[]} an array of dates
 */
export const getDatesArrayForRange = (startDate, endDate, precision = 'day') => {
    const range = [];
    let current = startDate.clone();
    while (!current.isAfter(endDate)) {
        range.push(current);
        current = current.add(1, precision);
    }
    return range;
};

/**
 * Return the same date last year (exact date, not SPIT)
 * @param  {moment} date
 * @return {moment} the date 1 year before the one passed
 */
export const getLYDateFor = (date) => date.clone().subtract(1, 'year');

/**
 * Return the same date at the same point in time last year (i.e. -52 weeks)
 * @param  {moment} date
 * @return {moment} the date 52 weeks before the one passed
 */
export const getLYSpitDateFor = (date, dayComparison = true) => {
    if (!dayComparison) {
        return date.clone().subtract(1, 'year');
    }
    return date.clone().subtract(52, 'weeks');
};

const compareDateBy = (d1, d2, precision) => {
    if (d1.isSame(d2, precision)) return 0;
    if (d1.isBefore(d2, precision)) return -1;
    return 1;
};

export const compareDateByDay = (d1, d2) => compareDateBy(d1, d2, 'day');
export const compareDateByMonth = (d1, d2) => compareDateBy(d1, d2, 'month');
